// src/components/VideoSection.jsx
import React from "react";

function VideoSection({
                          src,
                          title,
                          description,
                          autoPlay = false,
                          loop = false,
                          muted = false,
                          controls = true,
                          poster,
                          align = "center",          // "left" | "center" | "right"
                          maxWidth = "960px",
                          showFrame = true,
                          background = "dark",        // "dark" | "light" | "transparent"
                          backgroundColor,            // optional custom color (overrides background)
                      }) {
    if (!src) return null;

    // ----- local CSS -----
    const css = `
    .video-section {
      padding: 20px 0;
    }

    .video-section--align-left {
      text-align: left;
    }
    .video-section--align-center {
      text-align: center;
    }
    .video-section--align-right {
      text-align: right;
    }

    /* Background variants */
    .video-section--bg-dark {
      background-color: #14151a;
    }
    .video-section--bg-light {
      background-color: #ffffff;
    }
    .video-section--bg-transparent {
      background-color: transparent;
    }

    .video-section__content {
      margin: 0 auto;
      padding: 0 16px;
    }

    .video-section__header {
      margin-bottom: 16px;
    }

    .video-section__title {
      margin: 0 0 6px 0;
      font-size: 24px;
      font-weight: 600;
    }

    .video-section__description {
      margin: 0;
      font-size: 14px;
      opacity: 0.9;
    }

    .video-section__frame {
      border-radius: 16px;
      overflow: hidden;
    }

    .video-section__frame--shadow {
      box-shadow: 0 16px 40px rgba(0, 0, 0, 0.35);
    }

    .video-section__video {
      width: 100%;
      display: block;
      border: none;
      outline: none;
    }

    @media (max-width: 600px) {
      .video-section {
        padding: 24px 0;
      }
      .video-section__title {
        font-size: 20px;
      }
    }
  `;

    const sectionClass = [
        "video-section",
        `video-section--align-${align}`,
        background ? `video-section--bg-${background}` : "",
    ]
        .filter(Boolean)
        .join(" ");

    const frameClass = showFrame
        ? "video-section__frame video-section__frame--shadow"
        : "video-section__frame";

    return (
        <>
            {/* local styles */}
            <style>{css}</style>

            <section
                className={sectionClass}
                style={backgroundColor ? { backgroundColor } : undefined}
            >
                <div className="video-section__content" style={{ maxWidth }}>
                    {(title || description) && (
                        <header className="video-section__header">
                            {title && <h2 className="video-section__title">{title}</h2>}
                            {description && (
                                <p className="video-section__description">{description}</p>
                            )}
                        </header>
                    )}

                    <div className={frameClass}>
                        <video
                            className="video-section__video"
                            controls={controls}
                            autoPlay={autoPlay}
                            loop={loop}
                            muted={muted || autoPlay}
                            playsInline
                            poster={poster}
                        >
                            <source src={src} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                </div>
            </section>
        </>
    );
}

export default VideoSection;